<template>
  <div class="ui top fixed menu">
    <div class="row">
      <div class="field servicios">
        <img class="imgServiciosHapiick" src="../assets/servicios_hapiick.png">
        servicios hapiick
      </div>
      <div v-if="apmName" class="field apm">
        <img class="imgApmName" src="../assets/ubication.jpg">
        {{apmName}} 
      </div>

      <div class="field menuOptions" style="float:right">
        <img v-if="showMenuIcon" v-on:click="showMenuHeader()" class="imgMenuOptions" src="../assets/menuOptions.png">
        <i class="ui big close icon icon" v-if="showCloseIcon" v-on:click="showMenuHeader()"></i>
      </div>
    </div>
  </div>

  <div  v-if="showHeaderMenu" id="menuOptions">
    <button id="menuServices" class="btnsMenu" v-on:click="selectMenuOption('menuServices')">Menu</button>
    <button id="closeSession" class="btnsMenu" v-on:click="selectMenuOption('closeSession')">Cerrar Sesion</button>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: ['apm'],
  data() {
    return {
      showMenuIcon: true,
      showCloseIcon: false,
      apmName: null,
      msg: null,
      type: null,
      title: null,
      closeSession: 1,
      codError: null,
      showHeaderMenu: false
    }
  },
  created() {
  },
  watch: {
    $route: function(new_route) {
      if(!this.$apm_name) {
        this.apm_param = new_route.params.apm

        let url = this.$url_hapiick + "/v1/apms/name?apm="+this.apm_param;
        let headers = {
            'Content-Type': 'application/json',
        }
        if (this.$subscription !== '') {
          headers['Ocp-Apim-Subscription-Key'] = this.$subscription
        }

        this.axios.get(url,{
          headers: headers
        })
        .then(request => {
          this.apmName = request.data.apm_name
          this.$apm_name = this.apmName //Guardamos en la variable global el nombre de la maquina
        })
        .catch((error) => {
          if(error.request) {
            if (error.request.status == 429) {
              this.codError = error.request.status
              this.redirect(this.codError,this.title,'','',this.token,this.closeSession);
            } else {
              console.log(error.request)
            }
          }
        })
      } else {
        this.apmName = this.$apm_name
      }
    },
  },
  methods: {
    showMenuHeader() {
      if (localStorage.token) {
        let menu = document.querySelector('.menuOptions');
        menu.addEventListener('click', () => {
          let btnMenuServices = document.getElementById('menuServices');
          if (localStorage.virtualService_id) {
            btnMenuServices.disabled = false;
          } else {
            btnMenuServices.disabled = true;
          }
        });

        if (this.showHeaderMenu) {
          this.showHeaderMenu = false;
          this.showCloseIcon = false;
          this.showMenuIcon = true;
        } else {
          this.showHeaderMenu = true
          this.showCloseIcon = true;
          this.showMenuIcon = false;
        }
      }
    },
    selectMenuOption(opcion) {
      this.showHeaderMenu = false
      this.showCloseIcon = false;
      this.showMenuIcon = true;

      if (opcion === 'closeSession') {
        this.msg = 'Se ha cerrado la sesión.';
        this.type = 'info';
        this.codError = ''
        this.redirect(this.codError,this.title,this.msg, this.type,localStorage.token, this.closeSession);
      } else if (opcion === 'menuServices') {
        if (!localStorage.virtualService_id) {
          this.$swal({
            icon: 'error',
            text: 'Para acceder al menu de servicios, tienes que introducir el codigo de acceso.',
          })
        } else {
          this.$router.push({name: 'MenuService', params: {apm: this.apm_param, token: localStorage.token, virtualServiceId: localStorage.virtualService_id}});
        }
      }
    },
    redirect(codError, title, msg, type, token, closeSession) {  
      this.$router.push({name: 'Messages',params: {codError: codError, title: title, msg: msg, type:type, token:token, closeSession:closeSession}});
    },
  }
}
</script>

<style scoped>
img {
  padding-right: 10px;
}

#menuOptions {
  z-index: 1; 
  width:calc((100% / 2) + 20%); 
  height: auto; 
  color: black !important;
  border:1px solid grey;
  position: absolute;
  top: 10%;
  right: 0%;
  box-shadow: 0px 0px 10px grey!important;
}

#menuServices {
  border-bottom: 1px solid grey!important;
}

.ui.fixed.menu, .ui[class*="top fixed"].menu {
  height: 10%;
}

.header {
  border-bottom: solid 1px darkslategrey!important; 
  height: 15%;
}

.btnsMenu {
  height: 50px; 
  width:100%!important; 
  background-color: white;
  border: none!important;
}

.row {
  position: relative;
  width: 100%;
}

.servicios {
  width:35%;
}

.apm{
  width:55%;
}

.menuOptions{
  width:10%;
  height: 100%;
}

.field {
  text-align: left;
  height:100%;
  float: left;
  display: flex;
  align-items: center;
  padding: 0px 10px 0px 10px;
  line-height: normal;
  font-size: 14px;
}

.content {
  width: 100%;
  height: 100%;
}

.imgServiciosHapiick {
  width: 49px;
}

.imgApmName {
  width: 48px;
}

.imgMenuOptions{
  height: 30px;
}
</style>
